import React from "react";
import Select from "react-select";

const SearchableSelect = ({
  options,
  value,
  onChange,
  placeholder,
  isDisabled = false,
  isClearable = true,
  className = "",
}) => {
  // Custom filter function for better partial matching
  const customFilter = (option, inputValue) => {
    if (!inputValue) return true;

    // Normalize strings for better matching (remove extra spaces, convert to lowercase)
    const label = option.label.toLowerCase().trim();
    const input = inputValue.toLowerCase().trim();

    return (
      label.includes(input) ||
      label.startsWith(input) ||
      label.split(/\s+/).some((word) => word.startsWith(input)) ||
      label.split(/[-_./]/).some((part) => part.startsWith(input))
    );
  };

  // Custom styles to match the existing design
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      padding: "0 10px",
      backgroundColor: "white",
      borderRadius: "6px",
      border: "1px solid #d1d5db",
      boxShadow: state.isFocused
        ? "0 0 0 1px #6366f1"
        : "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
      borderColor: state.isFocused ? "#6366f1" : "#d1d5db",
      "&:hover": {
        borderColor: state.isFocused ? "#6366f1" : "#9ca3af",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "40px",
      padding: "0 6px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#111827",
    }),
  };

  // Find the selected option object
  const selectedOption =
    options.find((option) => option.value === value) || null;

  return (
    <Select
      styles={customStyles}
      options={options}
      value={selectedOption}
      onChange={onChange}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isSearchable={true}
      filterOption={customFilter}
      className={className}
      classNamePrefix="react-select"
      noOptionsMessage={({ inputValue }) =>
        inputValue
          ? `No options found for "${inputValue}"`
          : "No options available"
      }
      loadingMessage={() => "Loading..."}
      menuPlacement="auto"
      menuPosition="fixed"
    />
  );
};

export default SearchableSelect;
